/**
 * Состояние плашки-приглашения в localStorage, отдельно для каждого пользователя:
 * ${user_uuid}_tt-browser-notify = { snoozedUntil?: number, dismissed?: boolean }
 * `snoozedUntil` управляет приглашением, а `dismissed` скрывает подсказку о
 * заблокированных разрешениях. Оба поля сохраняются для совместимости со
 * старыми записями localStorage.
 */

const KEY_SUFFIX = "tt-browser-notify";
export const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

const storageKey = (userUuid) => `${userUuid}_${KEY_SUFFIX}`;

export const readPromptState = (userUuid) => {
  try {
    return JSON.parse(window.localStorage.getItem(storageKey(userUuid))) || {};
  } catch (error) {
    return {};
  }
};

const writePromptState = (userUuid, patch) => {
  try {
    window.localStorage.setItem(
      storageKey(userUuid),
      JSON.stringify({ ...readPromptState(userUuid), ...patch })
    );
  } catch (error) {
    // Приватный режим: плашка просто покажется снова.
  }
};

export const isSnoozed = (userUuid, now = Date.now()) =>
  Number(readPromptState(userUuid).snoozedUntil) > now;

export const snooze = (userUuid, now = Date.now()) =>
  writePromptState(userUuid, { snoozedUntil: now + SNOOZE_MS });

export const isDismissed = (userUuid) =>
  Boolean(readPromptState(userUuid).dismissed);

export const dismiss = (userUuid) =>
  writePromptState(userUuid, { dismissed: true });
